export default "__VITE_ASSET__D3XKpcnH__"